import { render, staticRenderFns } from "./Statistiques.vue?vue&type=template&id=0be16f3a&scoped=true"
import script from "./Statistiques.vue?vue&type=script&lang=js"
export * from "./Statistiques.vue?vue&type=script&lang=js"
import style0 from "./Statistiques.vue?vue&type=style&index=0&id=0be16f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be16f3a",
  null
  
)

export default component.exports